import { FontsCollection } from "#booster/classes/FontsCollection";
import { logDebug } from "#booster/utils/log";
import { injectHead, useRouter, useRuntimeConfig } from "#imports";
import { ref, watch, nextTick } from "vue";
export default function useBoosterHead() {
  const head = injectHead();
  const $router = useRouter();
  const {
    public: {
      booster: { debug }
    }
  } = useRuntimeConfig();
  const collection = ref(new FontsCollection());
  let headEntry;
  watch(
    () => collection.value,
    (value) => {
      const data = createEntry(value, debug);
      headEntry?.dispose();
      nextTick(() => {
        headEntry = head.push(() => data);
      });
    }
  );
  $router.beforeEach(() => {
    nextTick(() => {
      const items = collection.value.list.filter((item) => {
        return !disposeCollections.value.includes(item);
      });
      collection.value = new FontsCollection(items);
      disposeCollections.value = [];
    });
  });
  const disposeCollections = ref([]);
  const push = ({
    fontCollection,
    isCritical,
    options
  }) => {
    if (!collection) {
      throw new Error("pushFontCollection must be called before setupHead");
    }
    const notEmpty = !fontCollection.list.length;
    let value;
    if (notEmpty) {
      value = { fontCollection, isCritical, options };
      collection.value = new FontsCollection([...collection.value.list, value]);
      value = collection.value.list[collection.value.list.length - 1];
    }
    return {
      dispose: () => notEmpty && disposeCollections.value.push(value)
    };
  };
  return { push, collection };
}
function createEntry(collection, debug) {
  if (debug) {
    logDebug("Head Font Collections:", collection.toJSON());
  }
  const items = collection.list.filter(
    ({ fontCollection }) => fontCollection.size
  );
  return {
    link: import.meta.server || process.env.prerender ? prepareItems(
      items.filter(({ fontCollection }) => fontCollection.size).map(
        ({ fontCollection, isCritical }) => fontCollection.getPreloadDescriptions(isCritical)
      ).flat()
    ) : void 0,
    style: prepareItems(
      items.map(
        ({ fontCollection, options }) => fontCollection.getStyleDescriptions(options)
      ).flat()
    ),
    noscript: (import.meta.server || process.env.prerender) && prepareItems(
      items.map(
        ({ fontCollection }) => fontCollection.getNoScriptStyleDescriptions()
      ).flat()
    ) || void 0
  };
}
function prepareItems(items) {
  return Array.from(
    new Map(items.map((item) => [item.key, { ...item, key: void 0 }])).values()
  );
}
